import { useState } from 'react'
import CopyLinkButton from '../../components/Discord/CopyLinkButton'
import styles from '@/components/Discord/DiscordDocument.module.css'
import DiscordDocument from '@/components/Discord/DiscordDocument'

function DiscordServerSafetyAgeRestrictionPage() {
  const [language, setLanguage] = useState<'en' | 'cs'>('cs')
  const [activeRegion, setActiveRegion] = useState<'europe' | 'world'>('europe')

  const getSectionUrl = (sectionId: string) => {
    return `${window.location.origin}/discord/server-safety/age-restriction#${sectionId}`
  }

  return (
    <DiscordDocument language={language} onLanguageChange={setLanguage} heading={language === 'cs' ? (<div className={styles.titleSection}>
                <h1 className={styles.title}>Proč Discord žádá o datum mého narození?</h1>

              </div>) : (<div className={styles.titleSection}>
                <h1 className={styles.title}>Why is Discord asking for my birthday?</h1>

              </div>)} notice={<><div className={styles.disclaimer}>
            <div className={styles.disclaimerCard} lang="cs">
              <h3>Důležité upozornění</h3>
              <p>
                Nejsme přidruženi ani spojeni s Discord Inc. Toto je pouze komunitní překlad oficiálního článku o věkových omezeních Discord
                dostupného na <a href="https://support.discord.com/hc/en-us/articles/360040724612" target="_blank" rel="noopener noreferrer">support.discord.com</a>.
              </p>
              <p>
                Datum verze překladu je uvedeno výše. Pokud si všimnete, že obsah není aktuální, prosím, dejte nám vědět na našem Discord serveru.
              </p>
            </div>
            <div className={styles.disclaimerCard} lang="en">
              <h3>Important Notice</h3>
              <p>
                We are not affiliated with or associated with Discord Inc. This is only a community translation of the official Discord age restriction article
                available at <a href="https://support.discord.com/hc/en-us/articles/360040724612" target="_blank" rel="noopener noreferrer">support.discord.com</a>.
              </p>
              <p>
                The date of this translation is shown above. If you notice the content is outdated, please let us know on our Discord server.
              </p>
            </div>
          </div>
<div className={styles.linkLegend}>
            <h4>{language === 'cs' ? 'Legenda:' : 'Legend:'}</h4>
            <div className={styles.legendItem}>
              <span className={`${styles.legendLink} ${styles.discord}`}>
                {language === 'cs' ? 'Modré odkazy' : 'Blue links'}
              </span>
              <span>= {language === 'cs' ? 'oficiální Discord stránky' : 'official Discord pages'}</span>
            </div>
            <div className={styles.legendItem}>
              <span className={`${styles.legendLink} ${styles.internal}`}>
                {language === 'cs' ? 'Žluté odkazy' : 'Yellow links'}
              </span>
              <span>= {language === 'cs' ? 'naše přeložené stránky' : 'our translated pages'}</span>
            </div>
          </div></>}>

          {language === 'cs' ? (
            <>

              {/* Article body */}
              <div className={styles.articleBody}>
                <div className={styles.shieldIcon}>
                  <img src="https://support.discord.com/hc/article_attachments/360052376732" alt="discord_security_shield.png" />
                </div>

                <p className={styles.intro}>
                  Discord <a href="/discord/terms">Podmínky služby</a> vyžadují, aby lidé byli starší než minimální věk pro přístup k naší aplikaci nebo webové stránce, takže vyžadujeme, aby uživatelé potvrdili svůj věk, aby splnili tento minimální věkový požadavek. Tyto informace používáme v souladu s našimi Zásadami ochrany osobních údajů a k zajištění bezpečnosti našich uživatelů a zajištění toho, aby se nesetkali s materiálem, který pro ně není vhodný.
                </p>

                <div className={styles.infoBox}>
                  <h3>Například, pokud je vám mezi 13 a 17 lety, používáme informace o vašem věku k tomu, abychom zjistili, zda se můžete připojit k serverům nebo kanálům, které obsahují obsah s věkovým omezením (odpověď je <strong>ne</strong> – obsah s věkovým omezením je přístupný pouze uživatelům starším 18 let).</h3>
                </div>

                <p>Také je použijeme k lepšímu pochopení toho, jak používáte Discord, a ke zlepšení a personalizaci vaší uživatelské zkušenosti.</p>

                <div id="minimum-age" className={styles.minimumAge}>
                  <CopyLinkButton
                    url={getSectionUrl('minimum-age')}
                    language={language}
                    className={styles.copyBtn}
                  />
                  <h2>Minimální věk podle země</h2>
                  <p className={styles.highlight}>Pro všechny země, které nejsou uvedeny níže, je minimální věk pro přístup k naší aplikaci nebo webové stránce 13 let.</p>
                </div>

                <div className={styles.regionTabs}>
                  <button
                    className={`${styles.regionTab} ${activeRegion === 'europe' ? styles.active : ''}`}
                    aria-pressed={activeRegion === 'europe'} onClick={() => setActiveRegion('europe')}
                    type="button"
                  >
                    Evropa
                  </button>
                  <button
                    className={`${styles.regionTab} ${activeRegion === 'world' ? styles.active : ''}`}
                    aria-pressed={activeRegion === 'world'} onClick={() => setActiveRegion('world')}
                    type="button"
                  >
                    Zbytek světa
                  </button>
                </div>

                <div className={styles.regionsContent}>
                  {activeRegion === 'europe' ? (
                    <div className={styles.europeGrid}>
                      <div className={styles.countryList}>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Rakousko</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Bulharsko</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Chorvatsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Kypr</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={`${styles.countryItem} ${styles.highlighted}`}>
                        <span className={styles.countryName}>Česká republika</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Francie</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Německo</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Řecko</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Maďarsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Irsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Itálie</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Litva</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Lucembursko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Nizozemsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Polsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Rumunsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>San Marino</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Srbsko</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={`${styles.countryItem} ${styles.highlighted}`}>
                        <span className={styles.countryName}>Slovensko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Slovinsko</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Španělsko</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.worldGrid}>
                      <div className={styles.regionSection}>
                        <h4 className={styles.regionTitle}>Asie</h4>
                        <div className={styles.countryList}>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Jižní Korea</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Vietnam</span>
                          <span className={styles.age}>15+</span>
                        </div>
                        </div>
                      </div>

                      <div className={styles.regionSection}>
                        <h4 className={styles.regionTitle}>Karibik</h4>
                        <div className={styles.countryList}>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Aruba</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Karibské Nizozemsko</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Curaçao</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Sint Maarten</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        </div>
                      </div>

                      <div className={styles.regionSection}>
                        <h4 className={styles.regionTitle}>Jižní Amerika</h4>
                        <div className={styles.countryList}>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Chile</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Kolumbie</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Peru</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Venezuela</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>

              {/* Article body */}
              <div className={styles.articleBody}>
                <div className={styles.shieldIcon}>
                  <img src="https://support.discord.com/hc/article_attachments/360052376732" alt="discord_security_shield.png" />
                </div>

                <p className={styles.intro}>
                  Discord's <a href="https://discord.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> require people to be over a minimum age to access our app or website, so we require users to confirm their age to satisfy that minimum age requirement. We use this information in accordance with our Privacy Policy and to keep our users safe and ensure they don't encounter material that's not appropriate for them.
                </p>

                <div className={styles.infoBox}>
                  <h3>For example, if you are between the ages of 13 and 17, we use your age information to figure out whether you are able to join servers or channels that contain age-restricted content (the <a href="https://support.discord.com/hc/articles/1500005292701-Accessing-an-NSFW-Server-FAQ" target="_blank" rel="noopener noreferrer">answer</a> is <strong>no</strong>--age-restricted content is only accessible to users over 18).</h3>
                </div>

                <p>We'll also use it to better understand how you use Discord and improve and personalize your user experience.</p>

                <div id="minimum-age" className={styles.minimumAge}>
                  <CopyLinkButton
                    url={getSectionUrl('minimum-age')}
                    language={language}
                    className={styles.copyBtn}
                  />
                  <h2>Minimum Age by Country</h2>
                  <p className={styles.highlight}>For all countries not listed below, 13 is the minimum age to access our app or website.</p>
                </div>

                <div className={styles.regionTabs}>
                  <button
                    className={`${styles.regionTab} ${activeRegion === 'europe' ? styles.active : ''}`}
                    aria-pressed={activeRegion === 'europe'} onClick={() => setActiveRegion('europe')}
                    type="button"
                  >
                    Europe
                  </button>
                  <button
                    className={`${styles.regionTab} ${activeRegion === 'world' ? styles.active : ''}`}
                    aria-pressed={activeRegion === 'world'} onClick={() => setActiveRegion('world')}
                    type="button"
                  >
                    Rest of World
                  </button>
                </div>

                <div className={styles.regionsContent}>
                  {activeRegion === 'europe' ? (
                    <div className={styles.europeGrid}>
                      <div className={styles.countryList}>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Austria</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Bulgaria</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Croatia</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Cyprus</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={`${styles.countryItem} ${styles.highlighted}`}>
                        <span className={styles.countryName}>Czech Republic</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>France</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Germany</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Greece</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Hungary</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Ireland</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Italy</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Lithuania</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Luxembourg</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Netherlands</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Poland</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Romania</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>San Marino</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Serbia</span>
                        <span className={styles.age}>15+</span>
                      </div>
                      <div className={`${styles.countryItem} ${styles.highlighted}`}>
                        <span className={styles.countryName}>Slovakia</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Slovenia</span>
                        <span className={styles.age}>16+</span>
                      </div>
                      <div className={styles.countryItem}>
                        <span className={styles.countryName}>Spain</span>
                        <span className={styles.age}>14+</span>
                      </div>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.worldGrid}>
                      <div className={styles.regionSection}>
                        <h4 className={styles.regionTitle}>Asia</h4>
                        <div className={styles.countryList}>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>South Korea</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Vietnam</span>
                          <span className={styles.age}>15+</span>
                        </div>
                        </div>
                      </div>

                      <div className={styles.regionSection}>
                        <h4 className={styles.regionTitle}>Caribbean</h4>
                        <div className={styles.countryList}>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Aruba</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Caribbean Netherlands</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Curaçao</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Sint Maarten</span>
                          <span className={styles.age}>16+</span>
                        </div>
                        </div>
                      </div>

                      <div className={styles.regionSection}>
                        <h4 className={styles.regionTitle}>South America</h4>
                        <div className={styles.countryList}>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Chile</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Colombia</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Peru</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        <div className={styles.countryItem}>
                          <span className={styles.countryName}>Venezuela</span>
                          <span className={styles.age}>14+</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
    </DiscordDocument>
  )
}

export default DiscordServerSafetyAgeRestrictionPage
